"use client";
import { jsx as o } from "react/jsx-runtime";
import * as a from "@radix-ui/react-scroll-area";
import { forwardRef as e } from "react";
const s = e((r, l) => /* @__PURE__ */ o(a.Root, { "data-slot": "scroll-area", ...r, ref: l }));
s.displayName = "ScrollAreaRoot";
const i = e((r, l) => /* @__PURE__ */ o(a.Viewport, { "data-slot": "scroll-area-viewport", ...r, ref: l }));
i.displayName = "ScrollAreaViewport";
const t = e((r, l) => /* @__PURE__ */ o(a.Thumb, { "data-slot": "scroll-area-thumb", ...r, ref: l }));
t.displayName = "ScrollAreaThumb";
const m = e(({ children: r, ...l }, c) => /* @__PURE__ */ o(a.Scrollbar, { "data-slot": "scroll-area-scrollbar", ...l, ref: c, children: r ?? /* @__PURE__ */ o(t, {}) }));
m.displayName = "ScrollAreaScrollbar";
const S = e((r, l) => /* @__PURE__ */ o(a.Corner, { "data-slot": "scroll-area-corner", ...r, ref: l }));
S.displayName = "ScrollAreaCorner";
export {
  S as ScrollAreaCorner,
  s as ScrollAreaRoot,
  m as ScrollAreaScrollbar,
  t as ScrollAreaThumb,
  i as ScrollAreaViewport
};
